import { render, staticRenderFns } from "./PaymentsFilter.vue?vue&type=template&id=478e832c&"
import script from "./PaymentsFilter.vue?vue&type=script&lang=js&"
export * from "./PaymentsFilter.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsFilter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports